// src/i18n.js
// Mehrsprachigkeit via externe JSON-Dateien (public/locales/{lang}/translation.json)
// Neue Sprache hinzufügen: JSON-Datei anlegen + supportedLngs erweitern, fertig.

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "de", "it", "ja", "es", "pt", "fr", "ru", "pl", "tr"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    // Show keys while translations are loading (avoids blank flicker)
    react: { useSuspense: false },
  });

export default i18n;
